module.exports = __webpack_public_path__ + "img/393cd79.png";